var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "icon-block", class: _vm.classObject }, [
    _c("div", { staticClass: "icon-block__item" }, [
      _c(
        "div",
        { staticClass: "icon-block__icon" },
        [
          _vm.iconUrl
            ? _c("img", { attrs: { src: _vm.iconUrl } })
            : _c("z-icon", {
                attrs: {
                  name: _vm.iconName,
                  width: _vm.iconSize[_vm.size],
                  height: _vm.iconSize[_vm.size],
                },
              }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "icon-block__content" }, [_vm._t("default")], 2),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }